import { useNavigate } from 'react-router-dom'
import './Demo.scss'

const DemoComponent = (props: { icon: string, name: string, route: string, page: boolean }) => {

    const navigate = useNavigate()

    const OnClickDemo = (route: string, page: boolean) => {
        if (page)
            window.open(route, '_blank')
        else
            navigate(`/${route}`)
    }

    return (
        <div className='CardDemo' onClick={() => OnClickDemo(props.route, props.page)}>
            <img src={props.icon} />
            <span>{props.name}</span>
        </div>
    )

}

export default DemoComponent